import { Stack } from '@optimus-web/core';
import { getSortedProductCategoryIdsByOrdering } from '@mews-commander/legacy-entities/src/selectors/productCategories';
import { useCommanderSelector } from '@mews-commander/utils';
import { ProductServiceOrderProductListTable } from './ProductServiceOrderProductListTable';

interface OwnProps {
    serviceId: string;
    allowNegativeValues: boolean;
}

export const ProductServiceOrderProductList = ({ serviceId, allowNegativeValues }: OwnProps) => {
    const productCategoryIds = useCommanderSelector((state) =>
        getSortedProductCategoryIdsByOrdering(state, { serviceId })
    );

    return (
        <Stack vertical spacing="300">
            {productCategoryIds.map((productCategoryId) => (
                <ProductServiceOrderProductListTable
                    key={productCategoryId}
                    serviceId={serviceId}
                    productCategoryId={productCategoryId}
                    allowNegativeValues={allowNegativeValues}
                />
            ))}
            <ProductServiceOrderProductListTable
                serviceId={serviceId}
                productCategoryId={null}
                allowNegativeValues={allowNegativeValues}
            />
        </Stack>
    );
};
